import React, { Component } from 'react'
import { renderRoutes } from 'react-router-config'

import { awardUnit } from 'constants/wizards'
import { meta } from 'helpers/decorators'
import { Wizard } from 'components/masters'
import { WizardProgress } from 'components/layout'

@meta({
  title: 'Register award unit'
})
class AwardUnit extends Component {
  render() {
    const { route } = this.props
    const children = route && renderRoutes(route.routes)

    return (
      <Wizard
        items={awardUnit}
        wizardProgress={<WizardProgress {...this.props} />}
        {...this.props}
      >
        {children}
      </Wizard>
    )
  }
}

export default AwardUnit
